/** 
*@author: Sirisha.M
*@Description : 
**/
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import GraphView from './GraphView';
import queryString from 'query-string';
import { Button, Radio, message } from 'antd';
import localStorage from '../../utils/localStorage';
import { BackwardOutlined } from '@ant-design/icons';
import { API_DEVICE, FFT } from '../../commons/api.js';
import { NoRecordComponent } from '../Dashboard/ChartComponents/Utils';
import ViewDashboard from '../Dashboard/DashboardComponents/Dashboard';

const GraphViewComponent = (props) => {
    const [trendData, setTrendData] = useState({
        Device: 'CV-121',
        TimeStamp: '2022-01-06 14:07:59',
        FileName: '20220106173759.cna',
        FFTOutPut: {},
        xRanges: {
            gridIndex: 0,
            min: '0.000001',
            max: '0.058540'
        },
        yRanges: {
            gridIndex: 1,
            min: '0.000002',
            max: '0.113124'
        },
        zRanges: {
            gridIndex: 2,
            min: '0.000001',
            max: '0.059487'
        }
    });
    const [type, setType] = useState('graph');
    const [deviceList, setDeviceList] = useState([]);
    const [device, setDevice] = useState('');
    //   const [language, setLanguage] = useState(props.language || 'English');

    useEffect(() => {
        const params = queryString.parse(props.navigate.search);
        getDeviceList();
        graphView(params);
    }, [props.navigate.search]);

    const getDeviceList = () => {
        const siteId = localStorage.get('currentSite');
        const accessToken = localStorage.get('accessToken');
        const headers = {
            method: 'GET',
            url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        };
        axios(headers)
            .then((res) => {
                setDeviceList(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const graphView = (data) => {
        let siteId = localStorage.get('currentSite');
        const accessToken = localStorage.get('accessToken');
        const headers = {
            method: 'POST',
            url: `${FFT.Show}?SiteId=${siteId}`,
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
            data: {
                device: data.device,
                filename: [data.filename]
            }
        };
        axios(headers)
            .then((res) => {
                setTrendData(res.data && res.data[0] ? res.data[0] : {});
                setDevice(data.device);
            })
            .catch((error) => {
                if (error.response.status === 400 || error.response.status === 500) {
                    message.info(error.response.data.message);
                }
            });
    };

    const handleChange = (e) => {
        const type = e.target.value;
        setType(type);
    };

    return (
        <React.Fragment>
            <div
                style={{
                    padding: '20px',
                    backgroundColor: '#ffffff',
                    minHeight: window.innerHeight - 120
                }}
            >
                <div
                    style={{
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'center'
                    }}
                >
                    {deviceList.filter((deviceObject) => deviceObject.AliasCode.toString() === device).length > 0
                        ? `${deviceList.filter((deviceObject) => deviceObject.AliasCode.toString() === device)[0].DeviceCode}${deviceList.filter((deviceObject) => deviceObject.AliasCode.toString() === device)[0].DeviceDescription
                            ? `-${deviceList.filter((deviceObject) => deviceObject.AliasCode.toString() === device)[0].DeviceDescription}`
                            : ''
                        }  `
                        : device}
                </div>
                <Button
                    type="primary"
                    onClick={() => {
                        props.navigate('/rubus/FFT', { state: device ? device : '' });
                    }}
                >
                    <BackwardOutlined />
                    {props.translationCache && props.translationCache['FFT'] && props.translationCache['FFT']
                        ? props.translationCache['FFT']
                        : 'FFT'}
                </Button>
                <Radio.Group onChange={handleChange} value={type} style={{ float: 'right' }}>
                    <Radio.Button value="graph">FFT Graph</Radio.Button>
                    <Radio.Button value="summary">Summary</Radio.Button>
                </Radio.Group>

                {trendData && type === 'graph' ? (
                    <div>
                        {Object.keys(trendData).length !== 0 ? (
                            <GraphView
                                panelData={{
                                    graph: 'trends',
                                    trendData
                                }}
                            />
                        ) : (
                            <NoRecordComponent />
                        )}
                    </div>
                ) : (
                    <div>
                        <ViewDashboard match={{ params: { name: 'FFT', deviceId: device } }} />
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};

export default GraphViewComponent;
